import React from "react";
import { Card, Box, Typography, Avatar, Chip } from "@mui/material";
import { useTenant } from "../contexts/tenant-context";

const TenantInfoCard: React.FC = () => {
  const { selectedTenant } = useTenant();

  if (!selectedTenant) return null;


  return (
    <Card
      sx={{
        mb: 3,
        p: 2,
        backgroundColor: "#fff",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
      <Avatar
  variant="square"
  sx={{
    width: 90,
    height: 42,
    background: "hsl(19 101% 51% )",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    p: 0.5,
  }}
>
  {selectedTenant.logoUrl ? (
    <Box
      component="img"
      src={selectedTenant.logoUrl}
      alt={selectedTenant.tenantName}
      sx={{
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
      }}
    />
  ) : (
    selectedTenant.tenantName?.charAt(0)
  )}
</Avatar>
        <Box sx={{ flexGrow: 1 }}>
          <Typography fontWeight={700} color="hsl(19 101% 51% / 1)">
            {selectedTenant.tenantName}
          </Typography>

          <Typography fontSize={13} color="#000">
            Current Workspace
          </Typography>
        </Box>

      <Chip
          label={selectedTenant.role}
          sx={{
            background: "hsl(19 101% 51% / 0.2)",
            color: "hsl(19 101% 51% / 1)",
            fontWeight: 600,
          }}
        />

      </Box>
    </Card>
  );
};

export default TenantInfoCard;
